/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ICollectionSubtitleDetail } from '../collection-subtitle-schema';
import { collectionSubtitleDetailSchema } from '../collection-subtitle-schema';

export const getCollectionSubtitleResponseSchema = createApiResponseSchema(
  collectionSubtitleDetailSchema,
) as import('zod').ZodSchema<IAPI<ICollectionSubtitleDetail>>;

export type IGetCollectionSubtitleResponse = IAPI<ICollectionSubtitleDetail>;
